import React, { useEffect, useState } from 'react'
import { MdOutlineAccessTime, MdContentCopy, MdCheck, MdShare, MdEmail, MdSms } from "react-icons/md";
import { FaWhatsapp } from "react-icons/fa";
import { CiLocationOn } from "react-icons/ci";
import Rectangle from '../../util/Rectangle.png'
import RegistrationCourse from './RegistrationCourse';
import PaymentModal from './PaymentModal';
import SuccessAnimation from './SuccessAnimation';
import PaymentFailure from './PaymentFailure';
import { convertToIsraelTime } from '../../util/formatsForDate';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import ConfirmationModal from './ConfirmationModal';
import { MdLock } from "react-icons/md";
import PremiumPopup from './PremiumPopup';
import { useUser } from './UserProvider';
const Post = ({ course, key, Fromlink = "", getTrainingDays }) => {
  const {userDetails,setUserDetails } = useUser();
  const [currentStep, setCurrentStep] = useState(Fromlink&&!(userDetails?.activeDues)? "PremiumPopup" :Fromlink&&(userDetails?.activeDues)?Fromlink: "");
  const [errMess, setErrMess] = useState("");
  const [copied, setCopied] = useState(false);
  const [shareMenuOpen, setShareMenuOpen] = useState(false);

  const getShareUrl = () => `https://www.ismbonline.org/registrationTrainingDays?qId=${course?.mySelfQualificationDto?.id}`;
  const getShareText = () => course?.mySelfQualificationDto?.name || 'יום עיון';

  const handleShareToggle = (e) => {
    e.stopPropagation();
    setShareMenuOpen(prev => !prev);
  };

  const handleCopyLink = (e) => {
    e.stopPropagation();
    const url = getShareUrl();
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(url).catch(() => fallbackCopy(url));
    } else {
      fallbackCopy(url);
    }
    setCopied(true);
    setTimeout(() => { setCopied(false); setShareMenuOpen(false); }, 2000);
  };

  const fallbackCopy = (text) => {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.focus();
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
  };

  const handleWhatsApp = (e) => {
    e.stopPropagation();
    const text = encodeURIComponent(`${getShareText()}\n${getShareUrl()}`);
    window.open(`https://wa.me/?text=${text}`, '_blank');
    setShareMenuOpen(false);
  };

  const handleEmail = (e) => {
    e.stopPropagation();
    const subject = encodeURIComponent(getShareText());
    const body = encodeURIComponent(`${getShareText()}\n${getShareUrl()}`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
    setShareMenuOpen(false);
  };

  const handleSMS = (e) => {
    e.stopPropagation();
    const body = encodeURIComponent(`${getShareText()}\n${getShareUrl()}`);
    window.location.href = `sms:?body=${body}`;
    setShareMenuOpen(false);
  };
  const checkIfAlreadyDid = async (qId) => {
    try {
      const response = await axios.get(`dashboard/member/check_is_already_did_num_qul_period_year/${qId}`);

      if (response.status === 200) {
        setCurrentStep("payment");
      }
    } catch (error) {
      console.log(error)
      if (error.response && error.response.status === 409) {
        setCurrentStep("confirmation");
        setErrMess(error?.response?.data?.message)
      } else {
        console.error("אירעה שגיאה בלתי צפויה:", error);
        // אפשר להוסיף הודעת שגיאה למשתמש אם צריך
      }
    }
  };

  const location = useLocation();
  // const history = useHistory(); // שימוש ב-history לשלוח לדף אחר

  useEffect(() => {
    // שליפת פרמטרים מה-URL
    const queryParams = new URLSearchParams(location.search);
    const responseCode = queryParams.get('ResponseCode');
    // console.log("sd")
    // אם יש קוד שגיאה, נעבד את השגיאה
    if (Fromlink && responseCode) {

      const errorMessage = getErrorMessage(responseCode);
      setErrMess(errorMessage);
      setCurrentStep("error")

      // אם יש שגיאה, נשלח את המשתמש לדף כישלון
      // if (responseCode === "60000004") {
      //   setTimeout(() => {
      //     history.push('/payment-failure'); // דף כישלון בתשלום
      //   }, 3000); // מחכים 3 שניות לפני המעבר לדף אחר
      // }
    }
  }, []); // מתעדכן אם ה-URL משתנה

  // פונקציה שמחזירה הודעת שגיאה לפי ה-ResponseCode
  const getErrorMessage = (responseCode) => {
    switch (responseCode) {
      case "60000001":
        return "הכרטיס חסום לשימוש.";
      case "60000002":
        return "הכרטיס לא תקף.";
      case "60000003":
        return "עסקה לא אושרה על ידי הבנק.";
      case "60000004":
        return "פרטי כרטיס שגויים.";
      case "60000005":
        return "הכרטיס לא תואם לעסקה.";
      case "60000006":
        return "חיבור לרשת לא זמין.";
      case "60000007":
        return "זמן עסקה עבר.";
      case "60000008":
        return "מסגרת אשראי לא מספיקה.";
      default:
        return "שגיאה לא ידועה. אנא נסה שוב.";
    }
  };








  return (
    <>
      <div className='w-full flex flex-col relative shadow-lg rounded-lg p-1 border border-gray-200  '  onClick={() => course?.allow ? setCurrentStep("popup") : setCurrentStep("PremiumPopup")} key={key}
      // <div className='w-full flex flex-col relative shadow-lg rounded-lg p-1 border border-gray-200  '  onClick={() =>  setCurrentStep("PremiumPopup")} key={key}
      // onClick={setModalIsOpen}
      >
        {/* {!course?.allow && (
                <div className="absolute inset-0 bg-gray-200/60 backdrop-blur-[1px] flex items-center justify-center rounded-lg">
                  <MdLock className="text-gray-600" size={40} />
                </div>
              )} */}
        <div className='w-full flex flex-col ' >
          <div className='relative'>
            <img src={course?.mySelfQualificationDto?.linkImage ? `https://archivebureau.s3.eu-west-3.amazonaws.com/${course?.mySelfQualificationDto?.linkImage}` : Rectangle} alt="" className='rounded-t-lg w-full' />
            <div className='absolute top-2 right-2 z-20'>
              <button
                onClick={handleShareToggle}
                className='bg-white/80 hover:bg-white rounded-full p-1.5 shadow transition-colors'
                title='שתף'
              >
                <MdShare className='text-gray-600' size={18} />
              </button>
              {shareMenuOpen && (
                <>
                  <div className='fixed inset-0 z-10' onClick={(e) => { e.stopPropagation(); setShareMenuOpen(false); }} />
                  <div className='absolute top-8 right-0 bg-white rounded-lg shadow-lg border border-gray-200 py-1 min-w-[140px] z-30' style={{ direction: 'rtl' }}>
                    <button onClick={handleWhatsApp} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                      <FaWhatsapp className='text-green-500' size={16} />
                      <span>וואטסאפ</span>
                    </button>
                    <button onClick={handleEmail} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                      <MdEmail className='text-blue-500' size={16} />
                      <span>מייל</span>
                    </button>
                    <button onClick={handleSMS} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                      <MdSms className='text-purple-500' size={16} />
                      <span>SMS</span>
                    </button>
                    <button onClick={handleCopyLink} className='flex items-center gap-2 px-3 py-2 w-full hover:bg-gray-50 text-sm'>
                      {copied ? <MdCheck className='text-green-600' size={16} /> : <MdContentCopy className='text-gray-600' size={16} />}
                      <span>{copied ? 'הועתק!' : 'העתק קישור'}</span>
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* <h1 className='font-semibold text-sm text-black '>רשימת המתנה לפוליסת האחריות המקצועית של לשכת ממוני הבטיחות</h1> */}
          <h1 className='font-semibold text-sm text-black ' style={{ direction: "rtl" }}>{course?.mySelfQualificationDto?.name}</h1>
          <div className='flex items-center justify-end pr-3'>

            {/* <span className='text-[#595959] text-[1rem]'>11:30 am - 5:00 pm</span> */}
            <span className='text-[#595959] text-[1rem] my-1'>{convertToIsraelTime(course?.mySelfQualificationDto?.startDate)}</span>
            <MdOutlineAccessTime />
          </div>
          <div className='flex justify-end pr-3 text-right'>
            {/* <span>A5 Villa, Kochi</span> */}
            <span>{course?.mySelfQualificationDto?.place}</span>
            <CiLocationOn />
          </div>
        </div>
      </div>
      {(currentStep === "popup") && <RegistrationCourse course={course} onClose={() => setCurrentStep("")}
        //  onNext={() => {setCurrentStep("payment")}}
        onNext={() => checkIfAlreadyDid(course?.mySelfQualificationDto?.id)}
      />}
      {(currentStep === "payment") && <PaymentModal onClose={() => setCurrentStep("")} idCorse={course?.mySelfQualificationDto?.id} onBack={() => setCurrentStep("popup")} onNext={(ErrMess) => {
        setCurrentStep("success")
        setErrMess(ErrMess)
      }
      } getTrainingDays={getTrainingDays}
        // course={course} 
        name={course?.mySelfQualificationDto?.name}
        // price={course?.product?.price}
        price={course?.lastPrice}
        linkImage={course?.mySelfQualificationDto?.linkImage}
        request_register={"qualification"}
        onError={(ErrMess) => {
          setCurrentStep("error")
          setErrMess(ErrMess)
        }} />}
      {(currentStep === "success") && <SuccessAnimation onNext={() => setCurrentStep("")} getTrainingDays={getTrainingDays} titlerror={errMess} />}
      {(currentStep === "error") && <PaymentFailure onClose={() => setCurrentStep("")} error={errMess} titlerror={"התשלום נכשל"} />}
      {(currentStep === "confirmation") && <ConfirmationModal
        // onClose={() => setCurrentStep("") }
        onNext={() => { setCurrentStep("payment") }}
        onBack={() => setCurrentStep("popup")}

        message={errMess} />}

      {(currentStep === "PremiumPopup") && <PremiumPopup show={true} onClose={() => setCurrentStep("")}
        onNext={(ErrMess) => {
          getTrainingDays();
          setCurrentStep("success")
          setErrMess(ErrMess)
           setUserDetails( { ...userDetails, activeDues: true });


        }
        }
        onError={(ErrMess) => {
          setCurrentStep("error")
          setErrMess(ErrMess)
        }} />}

    </>
  )
}

export default Post